module.exports = __webpack_public_path__ + "img/salvager.1107f8a9.jpg";